angular.module('qkr.inventory').factory('variantDefinitionService', ['utils', 'variantInfrastructureService', 'variantHelperService', function(utils, variantInfrastructureService, variantHelperService) {
    const variantSetActions = {
        DELETE(variantInfrastructure, skusInUse, product, variantDefinitions) {
            variantInfrastructureService.deleteVariantSet(variantInfrastructure, skusInUse, this.variantSet);

            variantDefinitions = variantInfrastructureService.extractVariantsFromInfrastructure(variantInfrastructure);
            return variantDefinitions;
        },

        CREATE(variantInfrastructure, skusInUse, product, variantDefinitions) {
            return null;
        },

        MODIFY(variantInfrastructure, skusInUse, product, variantDefinitions) {
            return this.variantSetOptionDeltaAction.execute(variantInfrastructure, skusInUse, product, variantDefinitions);
        },

        REORDER(variantInfrastructure, skusInUse, product, variantDefinitions) {
            // Change the index of the summary and recalc
            variantInfrastructureService.reorderVariantDetails(variantInfrastructure, this.variantSet.variantType.text, this.variantSetIndex);

            variantDefinitions = variantInfrastructureService.extractVariantsFromInfrastructure(variantInfrastructure);
            return variantDefinitions;
        }
    };

    const variantSetOptionActions = {
        DELETE(variantInfrastructure, skusInUse, product, variantDefinitions) {
            variantInfrastructureService.deleteVariantOption(variantInfrastructure, skusInUse, this.variantSet.variantType.text, this.variantSetOption);

            variantDefinitions = variantInfrastructureService.extractVariantsFromInfrastructure(variantInfrastructure);
            return variantDefinitions;
        },

        CREATE(variantInfrastructure, skusInUse, product, variantDefinitions) {
            if (variantDefinitions.length > 0) {
                const variantBlueprint = new VariantBlueprint(variantDefinitions[0]);

                if (variantSetExists(this.variantSet, variantBlueprint)) {
                    addNewVariantDefinitionsForExistingVariantSet(variantInfrastructure, skusInUse, variantBlueprint, product, this.variantSet, this.variantSetOption);
                } else {
                    addNewVariantDetailToExistingVariantDefinitions(variantInfrastructure, this.variantSet, this.variantSetIndex, this.variantSetOption);
                }
            } else {
                createFirstVariantDefinition(variantInfrastructure, skusInUse, product, this.variantSet.variantType.text, this.variantSetOption, this.variantSet.optionColour);
            }

            variantDefinitions = variantInfrastructureService.extractVariantsFromInfrastructure(variantInfrastructure);
            return variantDefinitions;
        },

        REORDER(variantInfrastructure, skusInUse, product, variantDefinitions) {
            variantInfrastructureService.reorderVariants(variantInfrastructure, this.variantSet.variantType.text, this.variantSetOption, this.variantSetOptionIndex);

            variantDefinitions = variantInfrastructureService.extractVariantsFromInfrastructure(variantInfrastructure);
            return variantDefinitions;
        }
    };

    var addNewVariantDefinitionsForExistingVariantSet = function(variantInfrastructure, skusInUse, variantBlueprint, product, modifiedVariantSet, newVariantSetOption) {
        const variantSetIndex = getVariantSetIndex(variantBlueprint, modifiedVariantSet);

        if (variantSetIndex != -1) {
            variantInfrastructureService.addNewOptionToVariantSetSummary(variantInfrastructure, skusInUse, modifiedVariantSet.variantType.text, variantSetIndex, newVariantSetOption, product);
        }
    };

    var addNewVariantDetailToExistingVariantDefinitions = function(variantInfrastructure, variantSet, variantSetIndex, variantSetOption) {
        const variantDetail = variantInfrastructureService.createNewVariantDetail(true, variantSet.variantType.text, variantSetOption, variantSet.optionColour);
        const insert = variantSetIndex < variantInfrastructure.variantSetSummaries.length;

        const variantDefinitions = variantInfrastructureService.extractVariantsFromInfrastructure(variantInfrastructure);

        angular.forEach(variantDefinitions, (variantDefinition) => {
            const copyOfVariantDetail = angular.copy(variantDetail);

            if (insert) {
                variantDefinition.variantDetails.splice(variantSetIndex, 0, copyOfVariantDetail);
            } else {
                variantDefinition.variantDetails.push(copyOfVariantDetail);
            }
        });

        variantInfrastructureService.createInitialVariantSetSummary(variantInfrastructure, variantDetail, variantSetIndex);
        variantInfrastructureService.rebuildVariantSetInfrastructure(variantInfrastructure, variantDefinitions);
    };

    var createFirstVariantDefinition = function(variantInfrastructure, skusInUse, product, variantLabel, variantValue, optionColour) {
        let skuPattern = null;
        if (!utils.hasNoValue(product.sku)) {
            skuPattern = product.sku;
        }

        const sku = variantHelperService.getNextSkuForSkuPattern(variantInfrastructure, skusInUse, skuPattern);

        const variantDetail = variantInfrastructureService.createNewVariantDetail(true, variantLabel, variantValue, optionColour);
        const variant = variantInfrastructureService.createNewVariant(product.amountMinorUnits, sku, product.stockQuantity, true, false, [variantDetail]);

        variantInfrastructureService.createInitialVariantSetSummary(variantInfrastructure, variantDetail);
        variantInfrastructureService.addVariantToInfrastructure(variantInfrastructure, variant);
    };

    const getVariantBlueprint = function(variantDefinitions) {
        if (variantDefinitions != null && variantDefinitions.length > 0) {
            return new VariantBlueprint(variantDefinitions[0]);
        }
        return null;
    };

    var getVariantSetIndex = function(variantBlueprint, variantSet) {
        for (let index = 0; index < variantBlueprint.variantDetailBlueprints.length; index++) {
            const variantDetailBlueprint = variantBlueprint.variantDetailBlueprints[index];
            if (variantDetailBlueprint.variantLabel == variantSet.variantType.text) {
                return index;
            }
        }

        return -1;
    };

    var variantSetExists = function(variantSet, variantBlueprint) {
        for (let i = 0; i < variantBlueprint.variantDetailBlueprints.length; i++) {
            const variantDetailBlueprint = variantBlueprint.variantDetailBlueprints[i];
            if (variantDetailBlueprint.variantLabel == variantSet.variantType.text) {
                return true;
            }
        }

        return false;
    };

    var VariantBlueprint = function(variant) {
        this.variantDetailBlueprints = [];

        for (let i = 0; i < variant.variantDetails.length; i++) {
            const variantDetailBlueprint = new VariantDetailBlueprint(variant.variantDetails[i]);
            this.variantDetailBlueprints.push(variantDetailBlueprint);
        }
    };

    var VariantDetailBlueprint = function(variantDetail) {
        this.variantLabel = variantDetail.variantLabel;
    };

    return {
        VariantSetDeltaAction(variantSetActionLiteral, variantSet, variantSetIndex, variantSetOptionDeltaAction) {
            this.execute = variantSetActions[variantSetActionLiteral];
            this.variantSet = variantSet;
            this.variantSetIndex = variantSetIndex;
            this.variantSetOptionDeltaAction = variantSetOptionDeltaAction;
        },

        VariantSetOptionDeltaAction(variantSetOptionActionLiteral, variantSet, variantSetIndex, variantSetOption, variantSetOptionIndex) {
            this.execute = variantSetOptionActions[variantSetOptionActionLiteral];
            this.variantSet = variantSet;
            this.variantSetIndex = variantSetIndex;
            this.variantSetOption = variantSetOption;
            this.variantSetOptionIndex = variantSetOptionIndex;
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/inventory/services/variantDefinition.services.js